import React from 'react'
import { Divider, Table } from 'antd'
import BasicLayout from 'sdss/layouts/BasicLayout'

export function SearchRecordView() {

    const dataSource = [
        {
            key: '1',
            time: '2020-02-18 13:00',
            value: 'COPD',
            results: '4721条记录',
        },
        {
            key: '2',
            time: '2020-02-17 11:00',
            value: '新冠肺炎',
            results: '23421条记录',
        },
        {
            key: '2',
            time: '2020-02-11 08:00',
            value: '糖尿病',
            results: '5769条记录',
        },
    ]

    const columns = [
        {
            title: '时间',
            dataIndex: 'time',
        },
        {
            title: '搜索词',
            dataIndex: 'value',
            render: (text: string) => {
            return <span style={{ color: '#3260B6' }}>{text}</span>
            }
        },
        {
            title: '搜索结果',
            dataIndex: 'results',
        },
    ]
    
    return (
        <div data-flex="dir:top cross:center">
            <BasicLayout />
            <div style={{ width: 850, marginTop: 50 }}>
                <div>30天内的查询历史</div>
                <Divider />
                <Table dataSource={dataSource} columns={columns} pagination={false} />
            </div>
        </div>
    )
}
